import type { FaireProductEntity } from "../../entity_types/product";

export const p_mhjhrn98u2: FaireProductEntity = {
  token: "p_mhjhrn98u2",
  type: "product",
  name: "Mountain Reflection - Customizable -  Leather Patch Hat",
  brandToken: "b_1bd10jxt4j",
  brandName: "MT Brand Apparel",
  imageUrl: "https://cdn.faire.com/fastly/73f3b3278b044de4543c8889a95dbbc145a98c3dfe3185eb56432ba4279936a5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a31f58463b644bc5d8aad2f2f47aaf7aec9e189536e1fc45a7159120773af010.jpeg",
    "https://cdn.faire.com/fastly/c3428969fd5871fd0a895266b4f6f56390e3205bd3df870043b62d8b404bd29a.jpeg",
    "https://cdn.faire.com/fastly/2f8ffb7d36a4905f6be840d21fe0ad40ded642284729150dbd5025fc77bb92c3.jpeg"
  ],
  priceDollars: 15,
  description: "Our Mountain Reflection customizable Leather Patch Hat is a new design this winter. We will add your custom location in the space shown in the photo. We will replace Vermont with your customization. Enter your customization request in the space provided.\n\nNew Hat colors for 2025 are Terra Cotta/Beige & Mustard/Beige.\n\nOur hats are manufactured by Pacific Headwear, Adams, Mega Cap and Yupoong.\n\nPictured in Navy/White.\n\nMT Brand Apparel designs, engraves, prints and embroiders in Stevensville, Montana.",
  tags: [],
  msrpDollars: 30,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-09T08:03:50.981Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
